<template lang="pug">
    m-list-users(:loading="$wait.waiting(keys.search.users)"
                 :items="users"
                 :sort-items="sortItems"
                 v-bind.sync="query")

        template(#title="") {{$t('pages.system.search.subheading', {num: query.pagination.totalItems})}}
</template>

<script>
    import baseTab from "@mixins/components/modules/tabs/base";
    import {mapGetters, mapActions} from 'vuex'
    import debounce from 'lodash/debounce'

    import MListUsers from "@modules/lists/concrete/m-list-users";

    let name = 'm-tab-users';
    export default {
        name: name,
        mixins: [baseTab],
        components: {
            MListUsers,
        },
        props: {
            name: {
                type: String,
                default: name
            }
        },
        created() {
            // TODO: add constant for debounce timeout.
            this.debouncedRequest = debounce(this.requestUsers, 500);
            this.query.sort = this.sortItems.find((item) => item.default);
        },
        computed: {
            ...mapGetters({
                getUsers: 'search/getUsers'
            }),

            users() {
                return this.getUsers(this.query.sort);
            },

            sortItems() {
                return [
                    {
                        text: this.$t('modules.sorts.m-sort-users.alpha.asc'),
                        field: 'firstName',
                        order: 'asc'
                    }, {
                        text: this.$t('modules.sorts.m-sort-users.alpha.desc'),
                        field: 'firstName',
                        order: 'desc'
                    }, {
                        text: this.$t('modules.sorts.m-sort-users.created.desc'),
                        field: 'createdAt',
                        order: 'desc'
                    }, {
                        default: true,
                        text: this.$t('modules.sorts.m-sort-users.updated.desc'),
                        field: 'updatedAt',
                        order: 'desc'
                    }
                ]
            }
        },
        watch: {
            users(next, prev) {
                if(prev && prev.length > next.length) {
                    this.query.pagination.totalItems += (next.length - prev.length);
                }
            },
            'query.sort': function () {
                this.requestUsers();
            },
            'query.pagination': function (next, prev) {
                if (prev.currentPage !== next.currentPage) {
                    this.requestUsers();
                }
            },
            '$route.query.search': function () {
                this.debouncedRequest();
            },
            '$route.query.filters': function (next, prev) {
                if(!next || !prev || !this.$lodash.isEqual(this.parseQueryString(prev).users, this.parseQueryString(next).users))
                this.debouncedRequest();
            }
        },
        methods: {
            ...mapActions({
                loadUsers: 'search/searchUsers'
            }),

            async requestUsers() {
                if (!this.$wait.waiting(this.keys.search.users)) {
                    let query = {
                        sort: this.query.sort,
                        pagination: this.query.pagination,
                        filters: this.$route.query.filters ? (this.parseQueryString(this.$route.query.filters)).users : null
                    };
                    if( this.$route.query.search) {
                        query.search = {
                            string: this.$route.query.search
                        }
                    }
                    this.query.pagination = await this.loadUsers(query);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    //
</style>
